module.exports = __webpack_public_path__ + "img/interesting-stuff.31845190.png";